// Library
import axios from "axios";
import { toast } from "react-toastify";
// Services
import { API, JAVA_AUTH_API,} from "../../constants";
import {
  TypeForgotPassword,
  TypeLogin,
  TypeRefreshToken,
  TypeResetPassword,
} from "../../types";
import { setToken, clearToken, getToken, getRefreshToken } from "../storeToken";

// --- AUTH ---
// login functionality
export const logIn = (loginCredentials: TypeLogin, isExclusively: boolean) => {
  if (isExclusively) {
    return axios.post(JAVA_AUTH_API +"auth/signin-exclusively", loginCredentials);
  } else {
    return axios.post(JAVA_AUTH_API +"auth/signin", loginCredentials);
  };
};

// export const getActiveSession = () => {
//   return axios.get(API + "items/session?filter[status]=active&single=1");
// };

// forgot password functionality
export const forgotPassword = (resetPasswordInfo: TypeForgotPassword) => {
  return axios.post(API + "auth/password/request", resetPasswordInfo);
};

// reset password functionality
export const resetPassword = (resetPasswordInfo: TypeResetPassword) => {
  return axios.post(API + "auth/password/reset", resetPasswordInfo);
};

// refresh token functionality
export const refreshCurrentToken = (refreshTokenBody: TypeRefreshToken) => {
  const token = getToken();
  const header = { Authorization: `Bearer ${token}` };

  return axios.post(API + "auth/refresh", refreshTokenBody, {
    headers: header,
  });
};

// --- TEACHER ---
/* 
  get teacher profile for assessing info
  when the logged in user is of role teacher 
*/
export const getTeacherProfile = (teacherId: number) => {
  return axios.get(
    API +
    `items/teacher_profile?filter[user.id]=${teacherId}&fields=gradelist.*.*.*,school.*.*`
  ); // *.*.*.*   gradelist.*.*.*,school.*.*
};

// fetch logged in user's image
export const fetchImageOfUser = (fileId: number) => {
  return axios.get(API + `files/${fileId}`);
};

// --- PRINCIPLE ---
/* 
  get principle profile for assessing info
  when the logged in user is of role teacher 
*/
// fetches principle profile information
export const getPrincipleProfile = (principle_id: number) => {
  return axios.get(
    API +
    `items/principal_profile?filter[user]=${principle_id}&fields=*.*.*.*&single=1`
  );
};
// fetches district officer profile information
export const getDistrictOfficerProfile = (user_id: number) => {
  return axios.get(
    API +
    `items/district_official_profile?filter[user]=${user_id}&fields=district.*,district.state.*&single=1`
  );
};
// fetches district officer profile information
export const getBlockOfficerProfile = (user_id: number) => {
  return axios.get(
    API +
    `items/education_officer_profile?filter[user]=${user_id}&fields=block.*,block.district.*,block.district.state.*&single=1`
  );
};

//  --- ACTIONS ---
// user log out
export const logOut = () => {

  if (!getToken() || !getRefreshToken()) {
    toast.error("Unauthorized. Login and try again.");
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
};

  let payload = {
    accessToken: getToken(),
    refreshToken: getRefreshToken()
  };

  axios.post(`${JAVA_AUTH_API}auth/logout`, payload).then(
    response => {
      localStorage.clear();
      sessionStorage.clear();
      // if (sessionStorage.getItem("Token")) {
      //   clearToken();
      // }
      window.location.reload();
    }, error => {

      console.log("Error for logout: ", error?.response);
      if (error?.response?.status === 422 || error?.response?.status === 400) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
      };

    }
  )
};

// check if user is logged in or not
export const isLoggedIn = () => {
  if (typeof window == "undefined") {
    return false;
  }
  if (sessionStorage.getItem("Token")) {
    // return JSON.parse(sessionStorage.getItem("Token"));
    return true;
  } else {
    return false;
  }
};

// get logged in user's role
export const getUserRole = () => {
  return sessionStorage.getItem("role") || null;
};
